import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

interface Option {
  text: string
  value: server.dto.UnitsOfDistance
}

const metric: Option = {
  text: RESX.Distance.Kilometers,
  value: "metric",
};

const imperial: Option = {
  text: RESX.Distance.Miles,
  value: "imperial"
};

const UnitOfDistanceDropdown = (props: DropdownWithoutOptionsProps<server.dto.UnitsOfDistance, server.dto.UnitsOfDistance>) => {
  const value = props.value === "metric" ? metric : imperial;

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={[metric, imperial]}
    value={value}
    onChange={v => props.onChange(v.value)}
    getLabel={v => v.text}
    getValue={v => v.value}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />;
};

export default UnitOfDistanceDropdown;